import { useQuery } from "@tanstack/react-query";
import { fetchCustomer360 } from "../api/crm";

/** Fetches the Customer 360 snapshot for a single customer.
 *  5-min staleTime (shorter than list since user is actively viewing). */
export function useCustomer360(id: string) {
  return useQuery({
    queryKey: ["crm", "customer360", id],
    queryFn: () => fetchCustomer360(id),
    staleTime: 5 * 60 * 1000, // 5 min
    gcTime: 15 * 60 * 1000,
    enabled: Boolean(id),
  });
}
